// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";

function InputField(props) {
  let __autocomplete = props.autocomplete;
  let __labelClassName = props.labelClassName;
  let isFocus = props.isFocus;
  let __className = props.className;
  let __placeholder = props.placeholder;
  let __type_ = props.type_;
  let __fieldName = props.fieldName;
  let errorString = props.errorString;
  let __rightIcon = props.rightIcon;
  let onFocus = props.onFocus;
  let onBlur = props.onBlur;
  let onChange = props.onChange;
  let value = props.value;
  let setIsValid = props.setIsValid;
  let __id = props.id;
  let isValid = props.isValid;
  let __id_value = __id !== undefined ? __id : "";
  let __rightIcon_value = __rightIcon !== undefined ? __rightIcon : null;
  let __fieldName_value = __fieldName !== undefined ? __fieldName : "";
  let __type__value = __type_ !== undefined ? __type_ : "text";
  let __placeholder_value = __placeholder !== undefined ? __placeholder : "";
  let __className_value = __className !== undefined ? __className : "";
  let __labelClassName_value = __labelClassName !== undefined ? __labelClassName : "";
  let __autocomplete_value = __autocomplete !== undefined ? __autocomplete : "on";
  let match = React.useState(() => "input-base");
  let setEleClassName = match[1];
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$1.parentURL;
  let iframeId = match$1.iframeId;
  let options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.elementOptions);
  let contextPaymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  let paymentType = Core__Option.getOr(props.paymentType, contextPaymentType);
  let elementType = CardThemeType$OrcaPaymentPage.getPaymentModeToString(contextPaymentType);
  let setFocus = val => {
    if (onFocus !== undefined) {
      return onFocus(val);
    }
  };
  let setClass = val => {
    switch (paymentType) {
      case "Card" :
      case "CardNumberElement" :
      case "CardExpiryElement" :
      case "CardCVCElement" :
      case "PaymentMethodCollectElement" :
      case "PaymentMethodsManagement" :
        break;
      default:
        return;
    }
    setEleClassName(param => val);
  };
  let textColor = isValid !== undefined && !isValid ? "#eb1c26" : "";
  let setValidClasses = () => {
    if (isValid !== undefined) {
      if (isValid) {
        return setClass("input-complete");
      } else {
        return setClass("input-invalid");
      }
    } else {
      return setClass("input-base");
    }
  };
  let handleFocus = param => {
    if (value.length === 0) {
      setClass("input-empty");
    } else if (value.length > 0) {
      setValidClasses();
    }
    setFocus(true);
    setIsValid(param => {});
    Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL);
  };
  let handleBlur = ev => {
    if (value.length === 0) {
      setClass("input-base");
    } else if (value.length > 0) {
      setValidClasses();
    }
    setFocus(false);
    onBlur(ev);
    Utils$OrcaPaymentPage.handleOnBlurPostMessage(iframeId, elementType, parentURL);
  };
  React.useEffect(() => {
    if (value.length > 0) {
      setValidClasses();
    }
  }, [
    value,
    isValid
  ]);
  let direction = __type__value === "password" || __type__value === "tel" ? "ltr" : "";
  let isValidValue = CardUtils$OrcaPaymentPage.getBoolOptionVal(isValid);
  let match$2 = React.useMemo(() => {
    let isCardDetailsEmpty = value.length === 0 ? options.classes.base + ` ` + options.classes.empty + ` ` : options.classes.base;
    let isCardDetailsValid = isValidValue === "valid" ? ` ` + options.classes.complete + ` ` : "";
    let isCardDetailsInvalid = isValidValue === "invalid" ? ` ` + options.classes.invalid + ` ` : "";
    let isCardDetailsFocused = isFocus ? ` ` + options.classes.focus + ` ` : "";
    return [
      isCardDetailsEmpty,
      isCardDetailsValid,
      isCardDetailsInvalid,
      isCardDetailsFocused
    ];
  }, [
    isValid,
    setIsValid,
    value,
    onChange,
    onBlur
  ]);
  let concatString = [
    match$2[0],
    match$2[1],
    match$2[2],
    match$2[3]
  ].join("");
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
      [
        "id",
        iframeId
      ],
      [
        "concatedString",
        concatString
      ]
    ]);
  }, [
    isValid,
    setIsValid,
    value,
    onChange,
    onBlur
  ]);
  let errorClases = Core__Option.getOr(props.errorStringClasses, "");
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: __fieldName_value.length > 0,
        children: JsxRuntime.jsx("div", {
          children: __fieldName_value,
          className: __labelClassName_value
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("input", {
            ref: Primitive_option.some(props.inputRef),
            "aria-label": `Type to fill ` + __fieldName_value + ` input`,
            className: match[0] + ` ` + __className_value + ` focus:outline-none transition-shadow ease-out duration-200`,
            id: __id_value,
            style: {
              background: "transparent",
              color: textColor,
              width: "-webkit-fill-available"
            },
            autoComplete: __autocomplete_value,
            disabled: options.disabled,
            maxLength: props.maxLength,
            pattern: props.pattern,
            placeholder: __placeholder_value,
            type: __type__value,
            value: value,
            onKeyDown: props.onKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onChange: onChange
          }),
          JsxRuntime.jsx("div", {
            children: __rightIcon_value,
            className: `flex -ml-10  items-center`
          })
        ],
        className: "flex flex-row ",
        style: {
          direction: direction
        }
      }),
      errorString !== undefined ? JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: errorString.length > 0,
          children: JsxRuntime.jsx("div", {
            children: errorString,
            className: `py-1 ` + errorClases
          })
        }) : null
    ],
    className: ` flex flex-col w-full`
  });
}

let make = InputField;

export {
  make,
}
/* jotai Not a pure module */
